import { EnablePermanentJobM2M } from '~/constants/ff.posthog';
import PosthogService from './PosthogService';

export const FeatureFlagUtils = {
  isEnablePermanentJobM2M: () =>
    PosthogService.getInstance().isFeatureEnabled(EnablePermanentJobM2M),
};
